// Compatibility wrapper — invoice-specific calls into the unified audit
// log. Primary writers: invoiceService (create / updateInvoice /
// updateInvoiceStatus / deleteInvoice) and send-invoice-email
// (reminder_sent via _shared/auditEvent). voidInvoice audit is SERVER-SIDE
// in public.void_invoice (RD-AUD-013 M-05) — do not also emit from the client.
// Call sites keep importing from here so we don't churn imports. New code
// may import from `auditEvents.js` directly.
//
// RD-BILL-007 history:
//   • Originally wrote to a dedicated `invoice_events` table.
//   • Migration 20260509130000 unified that into `audit_events` with
//     entity_type / entity_id columns. This wrapper now translates
//     invoice-shaped calls into entity_type='invoice' rows.

import {
  writeAuditEvent,
  AUDIT_ENTITY_TYPES,
  AUDIT_EVENT_TYPES,
} from './auditEvents';

/** Re-exported for back-compat with existing imports. Mirrors the original
 *  per-invoice strings; values match auditEvents.js exactly. */
export const INVOICE_EVENT_TYPES = Object.freeze({
  CREATED: AUDIT_EVENT_TYPES.INVOICE_CREATED,
  SENT: AUDIT_EVENT_TYPES.INVOICE_SENT,
  PAID: AUDIT_EVENT_TYPES.INVOICE_PAID,
  VOIDED: AUDIT_EVENT_TYPES.INVOICE_VOIDED,
  DELETED: AUDIT_EVENT_TYPES.INVOICE_DELETED,
  STATUS_CHANGED: AUDIT_EVENT_TYPES.INVOICE_STATUS_CHANGED,
  EDITED: AUDIT_EVENT_TYPES.INVOICE_EDITED,
  REMINDER_SENT: AUDIT_EVENT_TYPES.INVOICE_REMINDER_SENT,
});

/** Append an invoice-related event. Identical contract to the original
 *  helper — fail-soft, never throws. */
export async function writeInvoiceEvent({ tenantId, invoiceId, eventType, payload = {}, actorName = null }) {
  return writeAuditEvent({
    tenantId,
    entityType: AUDIT_ENTITY_TYPES.INVOICE,
    entityId: invoiceId,
    eventType,
    payload,
    actorName,
  });
}
